export const buildPath = (pathParts) => {
    return pathParts.join('/');
};
